/*
  Ritual Collection v2
  1. Sign-up: when the Klaviyo embedded form on this page submits successfully,
     push a dataLayer event and go to the success page set in the section.
     (Klaviyo fires a window "klaviyoForms" event with detail.type = "submit".)
  2. Download: buttons/links marked [data-rc-download] save the PDF with a clean
     file name; if the browser blocks that, the file opens in a new tab instead.
*/
(() => {
    if (window.QOTTrc) return;
    window.dataLayer = window.dataLayer || [];

    // ---------- 1. Klaviyo sign-up → success page ----------
    let redirected = false;
    window.addEventListener('klaviyoForms', (e) => {
        const d = (e && e.detail) || {};
        if (d.type !== 'submit' || redirected) return;
        const wrap = document.querySelector('[data-rc-form]');
        if (!wrap) return;
        const formId = (wrap.dataset.formId || '').trim();
        if (formId && d.formId && String(d.formId) !== formId) return;

        redirected = true;
        window.dataLayer.push({ event: 'ritual_collection_signup', form_id: d.formId || formId });
        try { window.sessionStorage.setItem('qott_rc_signed_up', '1'); } catch (err) {}

        // No success page, or it points at this same page (e.g. Klaviyo's own
        // "Go to URL" is handling it): leave the redirect to Klaviyo.
        let url = wrap.dataset.successUrl || '';
        try {
            const target = new URL(url, window.location.href);
            if (target.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '')) url = '';
        } catch (err) { url = ''; }
        if (!url) return;
        const done = wrap.querySelector('[data-rc-done]');
        if (done) done.hidden = false;
        const delay = Math.max(0, parseInt(wrap.dataset.delay, 10) || 0);
        setTimeout(() => { window.location.href = url; }, delay);
    });

    // ---------- 2. Download ----------
    document.addEventListener('click', async (e) => {
        const link = e.target.closest('a[data-rc-download]');
        if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return;
        window.dataLayer.push({ event: 'ritual_collection_download', file_url: link.href });
        const name = link.dataset.filename;
        if (!name || !window.fetch || !window.URL || !URL.createObjectURL) return; // plain new-tab open

        e.preventDefault();
        if (link.classList.contains('is-loading')) return;
        link.classList.add('is-loading');
        try {
            const res = await fetch(link.href, { mode: 'cors', credentials: 'omit' });
            if (!res.ok) throw new Error('HTTP ' + res.status);
            const blob = await res.blob();
            const objectUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = objectUrl;
            a.download = name;
            document.body.appendChild(a);
            a.click();
            a.remove();
            setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
        } catch (err) {
            window.open(link.href, '_blank', 'noopener');
        } finally {
            link.classList.remove('is-loading');
        }
    });

    window.QOTTrc = true;
})();
